import { BriefcaseIcon } from "./BriefcaseIcon";
import { ChartBarIcon } from "./ChartBarIcon";
import { ClipboardIcon } from "./ClipboardIcon";
import { CompassIcon } from "./CompassIcon";
import { FolderIcon } from "./FolderIcon";
import { HexagonIcon } from "./HexagonIcon";
import { ShoppingBagIcon } from "./ShoppingBagIcon";
import { TargetIcon } from "./TargetIcon";
import { TVIcon } from "./TVIcon";
import { UserIcon } from "./UserIcon";

export {
  BriefcaseIcon,
  ChartBarIcon,
  ClipboardIcon,
  CompassIcon,
  FolderIcon,
  HexagonIcon,
  ShoppingBagIcon,
  TargetIcon,
  TVIcon,
  UserIcon,
};
